import { ExternalLink } from "lucide-react";

interface GoogleMapsFloatingLinkProps {
  latitude: number;
  longitude: number;
}

function googleMapsUrl(latitude: number, longitude: number) {
  const params = new URLSearchParams({
    api: "1",
    query: `${latitude},${longitude}`,
  });

  return `https://www.google.com/maps/search/?${params.toString()}`;
}

export function GoogleMapsFloatingLink({ latitude, longitude }: GoogleMapsFloatingLinkProps) {
  return (
    <a
      href={googleMapsUrl(latitude, longitude)}
      target="_blank"
      rel="noopener noreferrer"
      className="absolute bottom-3 right-3 z-[1000] inline-flex h-9 max-w-[calc(100%-1.5rem)] items-center gap-1.5 rounded-full border border-zinc-900/10 bg-white/95 px-3 text-xs font-bold text-zinc-900 shadow-[0_6px_18px_rgba(17,24,39,0.14)] backdrop-blur transition hover:bg-white focus:outline-none focus:ring-2 focus:ring-zinc-900/20"
    >
      <span>Googleマップで開く</span>
      <ExternalLink className="size-3.5 shrink-0" aria-hidden="true" />
    </a>
  );
}
